var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInitiated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#FFB547",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12L12 15.2M12 9.62817V9.60005M5.59998 16.0001L5.59998 7.99998C5.59998 6.67449 6.67449 5.59998 7.99998 5.59998L16 5.59998C17.3255 5.59998 18.4 6.67449 18.4 7.99998L18.4 16C18.4 17.3255 17.3255 18.4 16 18.4H7.99998C6.67449 18.4001 5.59998 17.3255 5.59998 16.0001Z",
    stroke: "#FFB547",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitiated);
export default __webpack_public_path__ + "static/media/initiated.a8faeba2e0dbdd128b1ef7ebacee804c.svg";
export { ForwardRef as ReactComponent };